export const IDASHBOARD_EMAIL_TEMPLATE = {
  to: 'help@iproperty.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello iDashboard

Could you please enable Snug as an upload destination for our agency for the iDashboard Account(s):

- [ Enter your iDashboard Agency ID here]

If required, please assign the iDashboard Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
